import React from 'react';
import { Shield } from 'lucide-react';
const HERO_BG = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesigne%202024/training-bg.jpeg?opt=w3';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 flex items-center border-b border-brand-gray-800 overflow-hidden" data-id="element-750">
      <img src={HERO_BG} alt="Law Enforcement Training" className="block absolute inset-0 w-full h-full object-cover" onError={e => {
      e.currentTarget.src = 'https://cdn.magicpatterns.com/uploads/6VNDFTEeWuRsoQPUmRUT27/law1.jpg';
    }} data-id="element-751" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/40 to-brand-black z-[1]" data-id="element-752" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center" data-id="element-753">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-6" data-id="element-754">
          <Shield className="w-4 h-4" data-id="element-755" />
          Specialized Training
        </div>
        <h1 className="text-4xl md:text-6xl font-extrabold text-brand-white tracking-tight leading-tight mb-6 uppercase" data-id="element-756">
          Law Enforcement Training <br className="hidden md:block" data-id="element-757" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-teal-light" data-id="element-758">
            And Our Capabilities
          </span>
        </h1>
      </div>
    </section>;
}